export default __webpack_public_path__ + "static/media/Folco Quilici.e75a901e.jpg";